// Stránky investičních bytů – harmonika častých dotazů.
// Markup: includes/template-parts/redesign/reality/faq.php. Otevřená je vždy nejvýš jedna
// odpověď, jako v návrhu. Výška se animuje přes grid-template-rows 0fr -> 1fr, nic se neměří.
// Stav drží třída `is-open` na `.re-faq__item` (viz _faq.scss) – `aria-expanded` na tlačítku se
// mění zároveň, ale jen kvůli přístupnosti, vzhled na něm nezávisí.

// Znaménko vpravo u otázky: − u otevřené, + u zavřené (reference apartmanyjeseniky.cz/js/app.js).
function setSign(question, open) {
  const sign = question.querySelector('.re-faq__sign');
  if (sign) {
    sign.textContent = open ? '−' : '+';
  }
}

export default function initRealityFaq() {
  const list = document.querySelector('[data-re-faq]');

  if (!list) {
    return;
  }

  const questions = Array.from(list.querySelectorAll('.re-faq__question'));

  questions.forEach((question) => {
    question.addEventListener('click', () => {
      const open = question.getAttribute('aria-expanded') === 'true';

      questions.forEach((other) => {
        other.setAttribute('aria-expanded', 'false');
        other.closest('.re-faq__item').classList.remove('is-open');
        setSign(other, false);
      });

      question.setAttribute('aria-expanded', open ? 'false' : 'true');
      question.closest('.re-faq__item').classList.toggle('is-open', !open);
      setSign(question, !open);
    });
  });
}
